// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9803c90c","440":"9e7fe05b","453":"eacce90d","455":"b7e5d0ee","551":"9adbcbc1","977":"d2408b7a"}[chunkId] + ".chunk.js";
};